import React from "react";
import { Link } from "react-router-dom";

import styles from "./OrderItem.module.scss";
import { OrderInterface } from "../../../common/types/interfaces";
import { orderRoute } from "../../../common/utils/constants";
import {
  getOrderStatusText,
  getStatusTextColor,
} from "../../../common/utils/functions/enumToText";
import { OrderStatus } from "../../../common/types/enums";

interface Props {
  order: OrderInterface;
  lastItemRef?: (node: HTMLAnchorElement | null) => void;
}

const formatDate = (iso: string) =>
  new Date(iso).toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

export const OrderItem: React.FC<Props> = ({ order, lastItemRef }) => {
  const cluster = order.cluster;

  return (
    <Link ref={lastItemRef} to={orderRoute(order.id)} className={styles.Row}>
      <span className={styles.BgNumber} aria-hidden="true">
        #{order.id}
      </span>

      <div className={styles.RowInfo}>
        <div className={styles.TopLine}>
          <div className={styles.ClusterLine}>
            {cluster && (
              <img
                src={`https://${cluster.domain}/icons/logo512.png`}
                alt={cluster.name}
                className={styles.ClusterLogo}
              />
            )}
            <span className={styles.ClusterName}>
              {cluster?.name || `Кластер #${order.clusterId}`}
            </span>
          </div>
        </div>

        <div className={styles.BottomLine}>
          <span
            className={styles.OrderStatus}
            style={{ color: getStatusTextColor(order.status as OrderStatus) }}
          >
            {getOrderStatusText(order.status as OrderStatus)}
          </span>
          <span className={styles.OrderDate}>
            {formatDate(order.createdAt)}
          </span>
          <span className={styles.OrderTotal}>{order.total} ₽</span>
        </div>
      </div>
    </Link>
  );
};
